<h1>Document History</h1>
    <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
    <div class="alert alert-info" *ngIf="history && history.length === 0">No signature history was found for this document.</div>
    <div class="col-12" *ngIf="history && history.length > 0">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title"></h5>
            <table class="table table-stripe ">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>
                    Action
                  </th>
                  <th>
                    Name
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let action of history">
                  <td>
                    {{action.date | date:'shortDate'}} {{action.date | date:'shortTime'}}
                  </td>
                  <td>
                      {{action.action}}
                  </td>
                  <td>
                    {{action.name}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
